import React from 'react'
import cls from 'classnames'
import styled from 'styled-components'

import withValidation from 'components/lib/inputs/withValidation'

const StyledInput = styled.input`
  font-size: 14px;
  width: ${(props) => props.width || '100%'};
  height: 35px;
  border: none;
  border-bottom: 1px solid
    ${(props) => (props.invalid ? props.theme.red : props.theme.primaryColor)};
  border-radius: 0;
  background-color: transparent;
  outline: none;
  &.error {
    border-color: ${(props) => props.theme.red};
  }
  &:disabled {
    opacity: 0.3;
  }
`

function Input({ popup, className, ...rest }) {
  return <StyledInput className={cls('is-input', className)} {...rest} />
}

Input.Field = withValidation(Input)

export default Input
